export default "__VITE_ASSET__ClJ7fy4l__"